import { render } from "./modal-download-list-cargo-v2.vue?vue&type=template&id=1f16b0e8&ts=true"
import script from "./modal-download-list-cargo-v2.vue?vue&type=script&lang=ts"
export * from "./modal-download-list-cargo-v2.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__